module.exports = __webpack_public_path__ + "media/images/emblems/Wegenstetten-blason-5d529112557bbc5f2c176044096cb68a.png";